import React from 'react';
import { Zap, Flame, Clock, Atom } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

const RJHTechnology = () => {
  const features = [
    {
      icon: Zap,
      title: 'Ultrafast Heating',
      description: 'Seconds-scale treatment enables rapid material transformation'
    },
    {
      icon: Flame,
      title: 'Extreme Temperatures',
      description: 'Achieve 600-3,000°C in controlled environments'
    },
    {
      icon: Clock,
      title: 'Rapid Turnaround',
      description: 'Complete processing in 1-60 seconds per sample'
    },
    {
      icon: Atom,
      title: 'Non-Equilibrium States',
      description: 'Access unique material structures impossible with conventional methods'
    }
  ];

  return (
    <section id="rjh-technology" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Rapid Joule Heating (RJH) Technology
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed max-w-4xl mx-auto">
            Rapid Joule Heating (RJH) is an advanced thermal treatment method that uses high electrical current to achieve 
            ultrafast heating rates. By passing electrical current through conductive materials mixed with your sample inside 
            a quartz tube, RJH enables rapid, high-temperature conversion that unlocks unique material properties unattainable 
            through conventional furnace processing.
          </p>
        </div>

        {/* Scientific Illustration */}
        <div className="text-center my-12 bg-gray-50 rounded-2xl p-8">
          <img 
            src="https://customer-assets.emergentagent.com/job_catching-energy/artifacts/sxby71ez_ChatGPT%20Image%20Jan%2031%2C%202026%2C%2007_18_17%20PM.jpg"
            alt="Rapid Joule Heating illustration"
            className="max-w-full h-auto mx-auto rounded-xl shadow-lg"
            style={{ maxHeight: '500px' }}
          />
        </div>

        {/* Unique Features */}
        <div className="mt-16">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">
            Unique Features of RJH
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {features.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <Card key={index} className="border-2 hover:border-green-600 transition-all duration-300 hover:shadow-lg">
                  <CardHeader>
                    <div className="w-12 h-12 bg-gradient-to-br from-green-600 to-blue-600 rounded-xl flex items-center justify-center mb-3">
                      <Icon className="w-6 h-6 text-white" />
                    </div>
                    <CardTitle className="text-lg">{feature.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-sm text-gray-600">{feature.description}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default RJHTechnology;
